import { enableAllPlugins } from 'immer';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { getSystemLanguage } from './common/utils';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { loadI18N } from './lib/i18n';
import './common/styles/globals.scss';
import 'dragscroll';

// eslint-disable-next-line func-names
(async function () {
    await loadI18N(getSystemLanguage());

    // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
    const { store } = await import('./store');
    // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
    const { App } = await import('./components/App/App');
    enableAllPlugins();

    const root = createRoot(document.getElementById('root') as HTMLElement);
    const Constructor = () => (
        <StrictMode>
            <Provider store={store}>
                <ErrorBoundary>
                    <App />
                </ErrorBoundary>
            </Provider>
        </StrictMode>
    );

    root.render(<Constructor />);
})();
